/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { HotelsFormComponent } from '@app/hotels/hotels/hotels-form/hotels-form.component';

@Injectable({
  providedIn: 'root',
})
export class HotelsFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open hotel form
   * @param hotel Dialog data
   */
  public open(hotel: null | Hotel = null): Promise<any> {
    const modal = this.modalService.open(HotelsFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.hotel = hotel;
    return modal.result;
  }
}
